export default "__VITE_ASSET__DQCS9ho3__"